module.exports = __webpack_public_path__ + "img/lying_face.98b46417.gif";